<template>
	<div :class="[mode == 'cd' ? 'cd-qty-add' : 'cp-qty-add', item.available_qty == 1 && 'single', {'instashop': mode == 'instashop'}]">
        <template v-if="item.is_available">
            <div :class="mode == 'cd' ? 'cd-qty' : 'cp-qty'">
                <BaseThemeWebshopQty :quantity="1" :limit="item.maximum_qty > 0 ? item.maximum_qty : 999" v-model="qty" />
                <span v-if="item.unit" :class="['cp-unit', mode == 'cd' && 'cd-unit']">{{item.unit}}</span>
                <span v-else :class="['cp-unit', mode == 'cd' && 'cd-unit']"><BaseCmsLabel code="unit" /></span>
            </div>
            <BaseWebshopAddToCart v-slot="{onAddToCart, loading}" :data="{modalData: item, shopping_cart_code: item.shopping_cart_code, quantity: qty}">
                <button type='button' :class="['btn btn-green', mode == 'cd' ? 'cd-btn-add' : 'cp-btn-addtocart', loading && 'loading']" @click="onAddToCart">
                    <UiLoader v-if="loading" />
                    <span v-else>
                        <BaseCmsLabel v-if="mode == 'cp' || mode == 'instashop'" code="to_cart" />
                        <BaseCmsLabel v-else code="add_to_shopping_cart" />
                    </span>
                </button>
            </BaseWebshopAddToCart>
        </template>
        <template v-else-if="mode == 'cd' && !item.is_available">
            <FeedbackNotificationForm status="not-available" :item="product" />
        </template>
	</div>
</template>

<script setup>
	const props = defineProps(['item', 'mode'])
	const qty = ref();
</script>

<style lang="less" scoped>
    .cp-qty-add{position: relative; display: flex; justify-content: center; width: 100%; margin: 15px 0 0; gap: 10px;}
    .cp-qty{
        position: relative; display: flex; width: 110px; flex-grow: 0; flex-shrink: 0; justify-content: center;
        :deep(input){
            padding: 0 40px; text-align: center; height: 48px;
            &.product_message_response_error{color: var(--textColor); border-color: var(--red);}
        }
        :deep(.qty-btn){width: 48px; height: 48px; min-width: 48px; min-height: 48px;}
    }
    .cp-unit{
        position: absolute; top: calc(~"100% - -3px"); text-align: center; font-size: 12px; line-height: 12px; text-transform: uppercase; display: block; width: 100%;
        &.cd{top: calc(~"100% - -5px");}
    }
    .cp-btn-addtocart{
        position: relative; display: flex; align-items: center; justify-content: center; width: 150px; height: 48px; padding: 0; flex-grow: 0; flex-shrink: 0; min-width: initial; margin: 0!important; color: var(--white); font-size: 18px; line-height: 23px;
        span{
            position: relative; display: inline-block; padding-left: 32px; color: var(--white);
            &:before{.pseudo(22px,22px); .icon-cart; font: 20px/22px var(--fonti); color: var(--white); top: -1px; left: 0;}
        }
        &.unavailable{
            span{
                padding-left: 0!important;
                &:before{display: none!important;}
            }
        }
    }    


    :deep(.qty-btn){
        position: absolute; left: 0; text-align: center; top: 0; height: 60px; width: 50px; margin: 0; display: block; font-size: 0; cursor: pointer;  z-index: 9; min-width: 50px; min-height: 60px;
        &:before{ .pseudo(14px,2px); left: 50%; margin-left: -7px; background: var(--primaryColor); top: 50%; margin-top: -1px;}
    }
    :deep(.qty-btn-inc){
        left: unset; right: 0;
        &:after{ .pseudo(2px,14px); background: var(--primaryColor); top: 50%; margin-top: -7px; left: 50%; margin-left: -1px;}
    }
    
    .cd-qty-add{display: flex; flex: 1 1 auto;}
    .cd-qty{
        width: 145px; height: 60px; position: relative; margin-right: 15px;
        :deep(input){width: 145px; height: 60px; border-radius: var(--borderRadius); padding: 0 50px; font-size: 20px; text-align: center; border: 1px solid var(--gray);}
    }


    @media (max-width: @t){
        .cp-btn-addtocart{
            min-width: inherit; width: 48px; height: 48px; font-size: 0; 
            span{padding: 0; width: 22px; height: 22px; flex-grow: 0; flex-shrink: 0;}
            &.unavailable{
                width: 150px; font-size: 16px; display: flex; align-items: center; justify-content: center;
                span{width: auto; height: auto;}
            }
        }	
        :deep(.qty-btn){height: 50px; width: 40px; min-width: 40px; min-height: 50px;}   
        .cd-qty{
            width: 115px; height: 50px; margin-right: 10px;
            :deep(input){width: 115px; height: 50px; padding: 0 40px; font-size: 18px;}
        }     
    }


    @media (max-width: @m){
        .cp-qty-add{margin-top: 10px; gap: 4px;}
        .cp-qty{
            width: 85px; gap: 4px;
            :deep(input){height: 40px; font-size: 13px; padding: 0 30px;}
            :deep(.qty-btn){width: 40px; height: 40px; min-width: inherit; min-height: inherit;}
        }

        :deep(.qty-btn){height: 44px; width: 30px; min-width: 30px; min-height: 44px;
            &:before{width: 12px; margin-left: -6px;}
        }
        :deep(.qty-btn-inc){
            &:after{height: 12px; margin-top: -6px;}
        }    

        .cp-btn-addtocart{
            width: 40px; height: 40px; min-width: initial; font-size: 0!important;
            span{
                width: 20px; height: 20px;
                &:before{width: 20px; height: 20px; font-size: 18px; line-height: 20px;}	
            }
            &.unavailable{font-size: 14px!important;}	
        }
        .cp-unit{top: calc(~"100% - -1px"); font-size: 10px; line-height: 12px;}    
        .cd-qty{
            width: 88px; height: 50px;
            :deep(input){height: 50px; width: 90px; font-size: 16px; padding: 0 30px;}
            :deep(.qty-btn){width: 36px; height: 50px; min-width: inherit; min-height: inherit;}
        }
    }

    //instashop
    .instashop{
        margin-top: 0;
        .cp-qty{display: none;}
        @media (max-width: @tp){
            .cp-btn-addtocart{
                width: 100%; font-size: 18px;
                span{width: unset; height: unset; padding-left: 32px;}
            }
        }
        @media (max-width: @m){
            .cp-btn-addtocart{
                font-size: 18px!important;
                span{padding-left: 29px;}
            }
        }
    }

</style>